

function SplitSectionReversed() {
    return (
        <section className="w-full bg-white py-16">
            <div className="container mx-auto flex flex-col md:flex-row items-center px-6 md:px-12 lg:px-20">
                
                {/* Left side: Image */}
                <div className="md:w-1/2 w-full mb-12 md:mb-0">
                    <img 
                        src="/food_two.jpg" 
                        alt="Happy children playing" 
                        className="rounded-lg shadow-lg w-full object-cover"
                    />
                </div>

                {/* Right side: Centered Text */}
                <div className="md:w-1/2 w-full flex items-center justify-center">
                    <div className="text-center">
                        <h2 className="text-4xl font-bold text-blue-900 mb-6">
                            Food with Care and Inclusion
                        </h2>
                        <p className="text-lg text-blue-900 mb-4 max-w-md mx-auto">
                            We understand that every child is unique. Whether your little one is weaning, vegetarian, or has allergies, meals are planned with care to suit their needs. Parents are always welcome to discuss dietary preferences, intolerances, and cultural requirements.
                        </p>
                        <p className="text-lg text-blue-900 mb-6 max-w-md mx-auto">
                            Mealtimes are calm, social, and part of the learning day. Children are encouraged to explore new tastes, sit together, and take part in light food prep or tidying up—building independence and a healthy relationship with food from the start.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default SplitSectionReversed;